import { render, staticRenderFns } from "./AppAgenda.vue?vue&type=template&id=56631dc8&"
import script from "./AppAgenda.vue?vue&type=script&lang=js&"
export * from "./AppAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports